import * as React from 'react';
import { UitkCardFeaturedHeader } from 'uitk-react-cards';
export var ActivitySpannedTileCardFeatureHeader = function (_a) {
  var activity = _a.activity;
  if (activity.features.pinnedTopBottom && activity.features.pinnedTopBottom.tileTop) {
    return React.createElement(UitkCardFeaturedHeader, {
      title: {
        tag: 'h4',
        text: activity.features.pinnedTopBottom.tileTop.description
      },
      "data-testid": "activity-spanned-tile-card-pinned-top-bottom-tile-top"
    });
  }
  return null;
};